<div class="container-fluid px-0 bg-dark d-none d-md-block" id="hero_nav">
  <div class="row">
    <div class="col">
      <ul class="d-flex list-group flex-md-row w-100 justify-content-around lemon-milk-light">
        <ng-container *ngFor="let category of categories">
          <!-- <li *ngIf="category.salons.length > 0 || category.slug === active_category?.slug" [class.active]="show_active && category.slug === active_category?.slug" class="list-group-item border-0 bg-dark"> -->
          <li routerLinkActive="active" class="list-group-item border-0 bg-dark d-flex align-items-center">
            <a class="text-light" (click)="setActiveCategory(category)" [routerLink]="link !== null ? link : '/categories/' + category.slug">
              {{ category.name }}
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>